import z from "zod/v4";

export const RegisterDeviceTokenRequest = z.object({
  token: z.string().min(1),
  platform: z.enum(["ios", "android"]),
  deviceId: z.string().min(1).optional(),
});

export type RegisterDeviceTokenRequest = z.infer<typeof RegisterDeviceTokenRequest>;

export const UnregisterDeviceTokenRequest = z.object({
  token: z.string().min(1),
});

export type UnregisterDeviceTokenRequest = z.infer<typeof UnregisterDeviceTokenRequest>;

export const CheckDeviceTokenQuery = z.object({
  token: z.string().min(1),
});

/** `GET /api/v1/device-tokens` with no `token`: whether any of the caller's devices can receive push now. */
export const ActiveDeviceStatus = z.object({
  hasActiveDevice: z.boolean(),
});

export type ActiveDeviceStatus = z.infer<typeof ActiveDeviceStatus>;
